module.exports = __webpack_public_path__ + "static/media/34_A.f21aa675.png";